import {Injectable} from '@angular/core';

export interface IStaffAccessPasswordResetLink {
  email: string;
  emailSent: boolean;
  passwordResetLink: string;
  emailError?: string;
}

@Injectable({
  providedIn: 'root',
})
export class StaffAccessPasswordResetLinkService {
  private readonly passwordResetLinksByEmail = new Map<string, IStaffAccessPasswordResetLink>();

  /**
   * Stores a newly created password-reset link for the Staff Access create flow.
   */
  setPasswordResetLink(result: IStaffAccessPasswordResetLink): void {
    this.passwordResetLinksByEmail.set(result.email.toLowerCase(), result);
  }

  /**
   * Retrieves and clears the password-reset link for the provided email.
   */
  consumePasswordResetLink(email: string): IStaffAccessPasswordResetLink | null {
    const normalizedEmail = email.toLowerCase();
    const result = this.passwordResetLinksByEmail.get(normalizedEmail) ?? null;
    this.passwordResetLinksByEmail.delete(normalizedEmail);
    return result;
  }
}
